import React, { useState, useEffect } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import SignUp from './components/Signup.js';
import Login from './components/Login.js';
import RestaurantLandingPage from './components/LandingPage.js';
import TermsOfService from './components/TermsOfService.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Boutique from "components/Boutique.js";
import './Boutique.css';
import './ProductDetails.css';
import './Checkout.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductDetails from "components/ProductDetails.js";
import CheckoutFrom from "components/CheckoutForm.js";
import ForgotPassword from "components/ForgotPassword.js";
import ResetPassword from "components/ResetPassword.js";
import Orders from "components/Admin/Orders.jsx";
import Profile from "components/Admin/Profile.js";
import OrdersAdmin from "components/AdminDashbord/Orders.jsx";
import ProduitsAdmin from "components/AdminDashbord/Produits.jsx";
import DashbordAdmin from "components/AdminDashbord/Dashbord.jsx";
import PaymentAdmin from "components/AdminDashbord/Payment.jsx";
import UserAdmin from "components/AdminDashbord/UserAdmin.jsx";
import ClientAdmin from "components/AdminDashbord/ClientAdmin.jsx";
import Retraite from "components/AdminDashbord/Retraite.jsx";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute component
import Contact from "Contact.js";
import About from "components/propos.jsx";
import './i18n'; // <-- this runs the i18n config
import LanguageSwitcher from "components/LanguageSwitcher.jsx";
import i18n from "./i18n"; // adjust path if needed
import AdminAnnouncement from "components/AdminDashbord/AdminAnnouncement.jsx";
import AnnouncementBanner from "components/AnnouncementBanner.jsx";
import WhatsAppButton from "components/WhatsAppButton.jsx";
import Parfums from "components/cards/Parfums.jsx";
import PackCadeaux from "components/cards/PackCadeaux.jsx";
import Cosmetique from "components/cards/Cosmetique.jsx";
import OrderConfirmation from "components/OrderConfirmation.jsx";
import Delivery from "components/AdminDashbord/Delivery.jsx";
import Point from "components/Admin/points.jsx";

export default function App() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const handler = (lng) => {
      const currentLang = lng || i18n.language;
      const dir = currentLang === "ar" ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", dir);
      document.documentElement.setAttribute("lang", currentLang);
    };
    handler(i18n.language);
    i18n.on('languageChanged', handler);
    return () => i18n.off('languageChanged', handler);
  }, []);
  useEffect(() => {
    const storedRole = localStorage.getItem('isAdmin'); 
    if (storedRole !== null) {
      setRole(storedRole);
    } else {
      setRole(''); 
    }
  }, []);
  if (role === null) {
    return <div>Loading...</div>;
  }
  
  return (
    <>
     <LanguageSwitcher />

      <GlobalStyles />
      <Router>
        {/* PageWrapper applies the sidebar spacing only on configured routes */}
        {
        }
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<RestaurantLandingPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/Boutique" element={<Boutique/>} />
          <Route path="/à-props" element={<About/>} />
          <Route path="/banner" element={<AnnouncementBanner/>} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
         <Route
  path="/product-details/:idAndSlug"
  element={<ProductDetails />}
/>
        <Route path="/point" element={<Point />} />

          <Route
            path="/checkout"
            element={
                <CheckoutFrom />
            }
          />
      
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashbord-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DashbordAdmin />
              </ProtectedRoute>
            }
          />
         
        
                  <Route
            path="/admin-announcement"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminAnnouncement/>
              </ProtectedRoute>
            }
          />
     
          <Route
            path="/order-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/produits-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProduitsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <PaymentAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
              <Route
            path="/Delivery"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Delivery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retraite"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Retraite />
              </ProtectedRoute>
            }
          />
          {/* Category routes */}
<Route path="/Cosmetique" element={<Cosmetique/>} />
<Route path="/PackCadeaux" element={<PackCadeaux/>} />
<Route path="/parfums" element={<Parfums/>} />

        </Routes>
        <WhatsAppButton />
      </Router>

    </>
  );
}